"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getContactListsAsSelectInputOptions = exports.getFetchContactListsRequestStatus = exports.getContactLists = void 0;

var _constants = require("./constants");

var _actions = require("./actions");

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getContactLists = function getContactLists(state) {
  return state[_constants.CONTACT_LISTS];
};

exports.getContactLists = getContactLists;
var getFetchContactListsRequestStatus = (0, _getRequestStatus.default)(_actions.ContactListsActionTypes.FETCH_CONTACT_LISTS);
exports.getFetchContactListsRequestStatus = getFetchContactListsRequestStatus;
var getContactListsAsSelectInputOptions = (0, _reselect.createSelector)([getContactLists], function (lists) {
  return lists.reduce(function (acc, list) {
    acc.push({
      value: list.get('listId'),
      text: list.get('name') + " (" + list.get('listSize') + ")",
      tagUse: 'oz'
    });
    return acc;
  }, []);
});
exports.getContactListsAsSelectInputOptions = getContactListsAsSelectInputOptions;